import axios from "axios";
import {
  Button,
  Checkbox,
  DocumentIcon,
  Pane,
  SelectField,
  Text,
  TextInputField,
} from "evergreen-ui";
import "./StyleB.css";
import { admission, mua } from "../../config/api";

import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import NewsList from "../../Components/NewsList";
function FormRegisterBandit() {
  const [NationSelect, setNationSelect] = useState("");
  const [Citizen, setCitizen] = useState("");
  const [Checkbo, setCheckbo] = useState(false);
  const [News, setNews] = useState([]);
  const citi = useRef(null);
  const [DataRob, setDataRob] = useState([]);
  const [Fetch, setFetch] = useState(false);
  const GetNews = (params) => {
    axios
      .get(
        admission + "/administrator_new/show/3"
        //  "http://git.kpru.ac.th/admission2017/administrator_new/show/3"
      )
      .then((res) => {
        const data = res.data;
        if (data.length !== 0) {
          console.log(data);
          setNews(res.data);
        } else {
          setNews([]);
        }
      });
  };

  useEffect(() => {
    axios
      .get(mua + "/admissionnew2022/showrobregister/" + localStorage.getItem("typestudent"))
      .then((ress) => {
        const datas = ress.data.data.data[0];
        const datac = ress.data.data.data;
        console.log(datac);
        if (datac.length !== 0) {
          // console.log(datas);
          setDataRob(datas);
        } else {
          setDataRob([]);
        }
        setFetch(true);
      });
    GetNews();
  }, []);
  useEffect(() => {}, [Fetch]);
  let headers = new Headers({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  const dataNation = [
    {
      value: "XX,ไม่มีสัญชาติ",
      label: "ไม่มีสัญชาติ",
      labelEN: "NO Nationality",
    },
    { value: "TH,ไทย", label: "ไทย", labelEN: "Thai" },
    { value: "CN,จีน", label: "จีน", labelEN: "China" },
    { value: "LA,ลาว", label: "ลาว", labelEN: "Lao" },
    { value: "MY,มาเลเซีย", label: "มาเลเซีย", labelEN: "Malasia" },
    { value: "MM,พม่า", label: "พม่า", labelEN: "Myanmar" },
    { value: "KH,กัมพูชา", label: "กัมพูชา", labelEN: "Cambodian" },
    { value: "ZZ,", label: "อื่นๆ", labelEN: "Other" },
  ];
  const [Loading, setLoading] = useState(false);
  const onChangeNation = async (e) => {
    const value = e.target.value;
    setNationSelect(value);
  };
  const Submit = () => {
    setLoading(true);
    if (NationSelect === "TH,ไทย") {
      setTimeout(() => {}, 20000);
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = Citizen.replace(/-/g, "");
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = total + pidcut * (13 - n);
        j++;
      }

      chk = 11 - (total % 11);

      if (chk === 10) {
        chk = 0;
      } else if (chk === 11) {
        chk = 1;
      }
      if (chk == Validchk) {
        setLoading(false);
        CheckRegister();
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "รูปแบบหมายเลขบัตรประจำตัวประชาชนไม่ถูกต้อง",
        }).then((res) => {
          citi.current.focus();
        });
      }
    } else {
      CheckRegister();
      setLoading(false);
    }
  };
  const setStorage = async (params) => {
    localStorage.setItem("citizent", Citizen);
    const nationData = NationSelect.split(",");
    localStorage.setItem("nation", nationData[0]);
    localStorage.setItem("nation_name", nationData[1]);
    console.log(DataRob);
    axios
      .post(
        mua + "/admissionnew2022/showcheckrobregister/",
        {
          robId: DataRob.ROB_ID,
          nation: nationData[0],
          nation_name: nationData[1],
          citizent: Citizen,
        },
        { headers }
      )
      .then((res) => {
        const token = res.data.data.auth;
        const data = res.data.data.data;
        if (data.length !== 0) {
          localStorage.setItem("citizent", Citizen);
          localStorage.setItem("typestudent", localStorage.getItem("typestudent"));
          localStorage.setItem("nation", nationData[0]);
          localStorage.setItem("nation_name", nationData[1]);
          localStorage.setItem("token", token);
          localStorage.setItem("robId", DataRob.ROB_ID);
          if (data[0].status_register !== 0) {
            // localStorage.getItem(
            //   "status_register",
            //   res.data.data.data[0].status_register
            // );
            if (localStorage.getItem("typestudent") === "3") {
              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregister-master`;
            } else if (localStorage.getItem("typestudent") === "4") {
              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregister-doctor`;
            }
          } else {
            localStorage.setItem("citizent", Citizen);
            localStorage.setItem("typestudent", localStorage.getItem("typestudent"));
            localStorage.setItem("nation", nationData[0]);
            localStorage.setItem("nation_name", nationData[1]);
            localStorage.setItem("token", token);
            localStorage.setItem("robId", DataRob.ROB_ID);
            if (localStorage.getItem("typestudent") === "3") {
              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister-master`;
            } else if (localStorage.getItem("typestudent") === "4") {
              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister-doctor`;
            }
          }
        } else {
          localStorage.setItem("citizent", Citizen);
          localStorage.setItem("typestudent", localStorage.getItem("typestudent"));
          localStorage.setItem("nation", nationData[0]);
          localStorage.setItem("nation_name", nationData[1]);
          localStorage.setItem("token", token);
          localStorage.setItem("robId", DataRob.ROB_ID);
          if (localStorage.getItem("typestudent") === "3") {
            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister-master`;
          } else if (localStorage.getItem("typestudent") === "4") {
            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister-doctor`;
          }
        }
      });
  };
  const CheckRegister = async (params) => {
    try {
      const fetch = await axios.get(
        mua + "/admissionnew2022/showlistregister?id=" + Citizen
      );
      const data = fetch.data.data.data.filter(
        ({ ROB_ID, Major1_MAJOR_ID, REGISTER_STATUS }) =>
          !(ROB_ID === "91" && Major1_MAJOR_ID === "1104" && REGISTER_STATUS === "11")
      );
      const datas = data[0];

      const check = data.filter(({ ROB_ID }) => ROB_ID === DataRob.ROB_ID);
      console.log(check.length);
      if (data.length !== 0) {
        if (check.length !== 0) {
          localStorage.setItem("citizent", Citizen);
          localStorage.setItem("statustitle", "");
          localStorage.setItem("ID_LOGIN", datas.ID_LOGIN);
          if (
            datas.REGISTER_STATUS === "0" ||
            datas.REGISTER_STATUS === "1" ||
            datas.REGISTER_STATUS === "2" ||
            datas.REGISTER_STATUS === "3" ||
            datas.REGISTER_STATUS === "4" ||
            datas.REGISTER_STATUS === "5" ||
            datas.REGISTER_STATUS === "11" ||
            datas.REGISTER_STATUS === "12" ||
            datas.REGISTER_STATUS === "91"
          ) {
            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
          } else if (
            datas.REGISTER_STATUS === "6" ||
            datas.REGISTER_STATUS === "7" ||
            datas.REGISTER_STATUS === "8" ||
            datas.REGISTER_STATUS === "9"
          ) {
            if (datas.ROB_ID !== "88") {
              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
            } else {
              window.location.href =
                admission + "/student_creckregister?ic=" +
                datas.ID_LOGIN;
            }
          }
        } else {
          setStorage();
        }
      } else {
        setStorage();
      }
    } catch (error) {}
  };

  return (
    <div className="container py-3">
      <Pane
        backgroundColor="white"
        padding={10}
        borderRadius={5}
        boxShadow="0px 0px 16px #00000030"
      >
        <Text fontSize={22} fontWeight={500}>
          สมัครเรียนระดับบัณฑิตวิทยาลัย มหาวิทยาลัยราชภัฏกำแพงเพชร
        </Text>
        <Pane className="pt-4 d-flex align-items-center m-0" flexWrap={"wrap"}>
          <div className="col-md-5 m-0">
            <SelectField
              label="สัญชาติ (Nationality)"
              onChange={onChangeNation}
              value={NationSelect}
            >
              <option>--เลือกสัญชาติ--</option>
              {Array.isArray(dataNation) &&
                dataNation.map((i, key) => (
                  <option value={i.value}>
                    {i.label} &nbsp;|&nbsp; {i.labelEN}
                  </option>
                ))}
            </SelectField>
          </div>
          <div className=" col-md-5 m-0">
            <TextInputField
              ref={citi}
              value={Citizen}
              name="citizenid"
              onChange={(e) => {
                setCitizen(e.target.value);
              }}
              label={
                NationSelect === "TH,ไทย"
                  ? "รหัสเลขบัตรประชาชน"
                  : "รหัสเลขบัตรประชาชน/เลขบัตร Passport"
              }
              placeholder={
                NationSelect === "TH,ไทย"
                  ? "รหัสเลขบัตรประชาชน"
                  : "รหัสเลขบัตรประชาชน/เลขบัตร Passport"
              }
            />
          </div>
          <div className="col-md-2 m-0 px-2 d-flex justify-content-end align-items-center">
            <Button
              onClick={Submit}
              iconBefore={<DocumentIcon />}
              isLoading={Loading}
              disabled={Checkbo !== false && Citizen !== "" && NationSelect !== "" ? false : true}
              appearance="primary"
              intent="success"
            >
              เริ่มกรอกข้อมูลสมัคร
            </Button>
          </div>
          <div className="col-12 m-0 d-flex mt-2 align-items-center">
            <Checkbox checked={Checkbo} onChange={() => setCheckbo(!Checkbo)} /> &nbsp;{" "}
            <span style={{ fontSize: "clamp(6px ,40rem ,14px)" }}>
              ข้าพเจ้ายืนยันว่าได้ศึกษาข้อมูลหลักสูตร สาขาวิชา และคณะที่เปิดรับสมัคร
              จากเอกสารข้างต้นเรียบร้อยแล้ว
            </span>
          </div>
        </Pane>
      </Pane>
      {News.length !== 0 ? (
        <div className="mt-4 mb-3">
          <NewsList items={News} previewCount={3} collapsible />
        </div>
      ) : null}
    </div>
  );
}

export default FormRegisterBandit;


